export const SET_PAGINATION = 'SET_PAGINATION';

export const GET_DATA_TABLE = 'GET_DATA_TABLE';
export const GET_DATA_TABLE_SUCCESS = 'GET_DATA_TABLE_SUCCESS';
export const GET_DATA_TABLE_FAILED = 'GET_DATA_TABLE_FAILED';
export const SET_FIREBASE = 'SET_FIREBASE';
